import * as React from 'react';
import { useTranslation } from 'react-i18next';
export const FareCode = ({ passengersRules }) => {
    const { t } = useTranslation('FareConditions');
    if (!(passengersRules === null || passengersRules === void 0 ? void 0 : passengersRules.length)) {
        return null;
    }
    const codes = passengersRules.reduce((acc, passengerRules) => {
        var _a, _b;
        if ((_b = (_a = passengerRules === null || passengerRules === void 0 ? void 0 : passengerRules.rules) === null || _a === void 0 ? void 0 : _a[0]) === null || _b === void 0 ? void 0 : _b.fareCode) {
            acc.push(passengerRules.rules[0].fareCode);
        }
        return acc;
    }, []);
    return (React.createElement(React.Fragment, null,
        t('Fare code'),
        ": ",
        codes.join(', ')));
};
export default FareCode;
